<section class="section white-100" *ngIf="streamlineData">
  <div class="section-container-inside">
    <div class="product-blog-subheading mar-b-16 align-c">
      {{ streamlineData?.tagName }}
    </div>
    <h2 class="section-heading mar-b-32">
      {{ streamlineData?.header }}
    </h2>
    <p class="section-description mar-b-48 align-c">
      <span class="wid-75">
        {{ streamlineData?.description }}
      </span>
    </p>
    <div class="section-efficient-payment">
      <ng-container *ngFor="let card of streamlineData?.cards; let i = index">
        <div
          class="efficient-payment padd-32"
          [ngClass]="
            i === 0
              ? 'blue-100'
              : i === 1
                ? 'pink-100'
                : i === 2
                  ? 'yellow-100'
                  : ''
          "
        >
          <div class="product-landing-content">
            <h5 class="efficient-payment-heading">
              {{ card?.fields?.richTextTitle?.content[0]?.content[0]?.value }}
              <span
                *ngIf="
                  card?.fields?.richTextTitle?.content[0]?.content[0]?.value ===
                  'Card Issuing API'
                "
                class="badge-style"
                >Coming Soon</span
              >
            </h5>
            <div
              class="efficient-payment-description"
              [innerHtml]="card?.fields?.description | toHtml"
            ></div>
          </div>
          <figure>
            <img
              loading="lazy"
              src="{{ card?.fields?.iconImage?.fields?.file?.url }}"
              alt="{{ card?.fields?.iconImage?.fields?.title }}"
              class="product-landing-img"
            />
          </figure>
        </div>
      </ng-container>
    </div>
  </div>
</section>
